import { createContext } from 'react';
import type { FeatureGateName } from './gates';

/**
 * Provider-agnostic gate reader consumed by `useFeatureGate`. The Statsig
 * provider (commercial) and the config provider (GovCloud, backed by the
 * `/api/v1/feature-flags` endpoint) each publish one of these so call sites
 * never know which backend evaluated the gate.
 */
export interface FeatureFlagClient {
  checkGate(name: FeatureGateName): boolean;
  // `false` while gates are still loading, `true` once they've resolved (even
  // on error). Lets route-level gates wait instead of redirecting on a value
  // that's only `false` because the fetch is in flight.
  isReady(): boolean;
}

/**
 * `null` when no provider is mounted (logged-out, pre-init, or unit tests with
 * no wrapper). `useFeatureGate` treats `null` as fail-closed — every gate reads
 * `false` — matching the contract that predates the provider split.
 */
export const FeatureFlagClientContext = createContext<FeatureFlagClient | null>(null);
